<template>
  <v-layout>
    <v-avatar class="shrink ma-1" size="16">
      <v-icon size="16">picture_as_pdf</v-icon>
    </v-avatar>

    <v-col class="pa-0 grow truncate">
      <span class="caption px-0 py-0 truncate">{{ resource.text || pdfInfo.name }}</span>
    </v-col>
  </v-layout>
</template>

<script>
export default {
  props: {
    resource: { default: () => ({}) },
    pdfInfo: { default: () => ({}) },
    
  },
  data() {
    return {
    };
  },
  computed: {},
  methods: {}
};
</script>

<style>
.site-info div {
  line-height: 1.3 !important;
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
